<template lang="pug">
    v-layout(:class="name")
        v-flex
            e-typography-body-secondary(:tag="attributeTag" :class="bodySmallClass") {{ createdAt }}
            e-typography-body-secondary(v-if="item.lastLogin" :tag="attributeTag" :class="bodySmallClass") {{ loginAt }}
            e-typography-body-secondary(:tag="attributeTag" :class="bodySmallClass") {{ status }}
            e-typography-body-secondary(:tag="attributeTag" :class="bodySmallClass" v-if="this.isOwner") {{ verified }}

</template>

<script>
    import arrangement from "@mixins/positioning/_arrangement";
    import {hasRole} from "@utils/user";
    import {roles} from "@constants/abilities";

    let name = 'm-list-user-attributes';

    export default {
        name: name,
        mixins: [arrangement],
        props: {
            name: {
                type: String,
                default: name
            },
            item: {
                type: Object,
                required: true
            }
        },
        computed: {
            isOwner(){
              return hasRole(this.item, roles.owner);
            },
            attributeTag() {
                return this.breakpoints.isMobile ? 'div' : 'span';
            },
            createdAt() {
                return this.$t(`modules.lists.${this.name}.text.created-at`, {
                    date: this.$d(new Date(this.item.createdAt),
                        'two_dig_dmyhm', 'de-DE')
                });
            },

            loginAt() {
                return this.$t(`modules.lists.${this.name}.text.login-at`, {
                    date: this.$d(new Date(this.item.lastLogin),
                        'two_dig_dmyhm', 'de-DE')
                });
            },

            status() {
                return this.$t(`modules.lists.${this.name}.text.status`, {
                    status: this.$t(`statuses.user.${this.item.status}`)
                });
            },

            verified() {
                return this.$t(`modules.lists.${this.name}.text.verified`, {
                    verified: this.$t(`boolean.${this.item.verified}`)
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
  .m-list-user-attributes {
    span {
      white-space: nowrap;
      display: inline-block;
      padding-right: 0.5rem;
      margin-right: 0.5rem;
      line-height: 1rem;
      border-right: 1px solid;
    }

    span:last-child {
      border-right: none;
    }
  }
</style>
